import * as Sentry from '@sentry/react';

import {config} from './app.config';

export function getReplaysSessionSampleRate(environment: string): number {
  switch (environment) {
    case 'production':
      return 1.0;
    case 'stage':
      return 0.5;
    default:
      return 0.1;
  }
}

export function initSentry(): void {
  if (!config.sentryDsn) return;

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment,
    release: `sollapay@${config.appVersion}`,
    integrations: [
      Sentry.consoleLoggingIntegration({levels: ['log', 'warn', 'error']}),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({maskAllText: false, blockAllMedia: false})
    ],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', config.apiUrl],
    replaysSessionSampleRate: getReplaysSessionSampleRate(config.environment),
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true
  });
}
